import classes from "../../styles/components/statusButtons.module.scss";

function StatusDevelopmentButton() {
    return(
        <button className={`${classes.progress} ${classes.button}`}>● development</button>
    );
}

export default StatusDevelopmentButton;